import { fecthPost } from '@/hotelcem/apis/request'

export default {
  /**
   * 翻译
   * @param {Object} params {"language": "默认跟随全局en, zh-cn","textList": []}
   * @returns Object
   */
  textTranslate(params, config) {
    return fecthPost('/cem/common/text/translate', params, config)
  },
}
